import { PropsWithChildren } from 'react'

import { createApiContractRepository } from '@/Contract/infrastructure'
import { AccountingStatusProvider } from '@/Contract/ui/context'
import { useUserData } from '@/User/ui/context'

export const AppUserProviders = ({ children }: PropsWithChildren): JSX.Element => {
  const { user, merchant } = useUserData()

  if (!user || !merchant) {
    return <>{children}</>
  }

  return (
    <AccountingStatusProvider
      merchantId={merchant.id}
      repository={createApiContractRepository()}
    >
      {children}
    </AccountingStatusProvider>
  )
}
